import { useEffect } from 'react';
import { createZodFormResolver, useFormControls } from '@mews/framework';
import { isDuplicateRoleNameError } from '../utils';
import { CreateRoleFormValues, createRoleSchema } from '../schema';
import { useCreateRole } from './queries';
import { CreateRoleFormFieldNames, defaultValues } from './formMapping';

const resolver = createZodFormResolver<CreateRoleFormValues>(createRoleSchema);

export const useCreateRoleFormControls = ({ onSuccess }: { onSuccess: () => void }) => {
    const { error, isPending, mutate } = useCreateRole();

    const onSubmit = (role: CreateRoleFormValues) =>
        mutate(role, {
            onSuccess,
        });

    const {
        setError,
        reset: internalReset,
        ...other
    } = useFormControls<CreateRoleFormValues>({
        defaultValues,
        onSubmit,
        resolver,
    });

    useEffect(() => {
        if (error instanceof Error && isDuplicateRoleNameError(error)) {
            setError(CreateRoleFormFieldNames.Name, { type: 'validate', message: error.message });
        }
    }, [error, setError]);

    // Since the form is not being mounted/unmounted, we need to reset the form when the default values change
    useEffect(() => {
        internalReset(defaultValues);
    }, [internalReset]);

    return { ...other, reset: () => internalReset(defaultValues), isLoading: isPending };
};
